/**
 * @generated SignedSource<<b80e112b9582dc36fc8213d363b8cdfd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContributionsMapContributionsMarkers_map",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionsMapThemeContributionsMarkers_map"
    }
  ],
  "type": "ContributionsMap",
  "abstractKey": null
};

node.hash = "5850ec0935afc6386f3d3f8fff120923";

module.exports = node;
